// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const TestExecutionStatus = {
  "SCHEDULED": "SCHEDULED",
  "STARTED": "STARTED",
  "STOPED": "STOPED",
  "SUBMITTED": "SUBMITTED"
};

const QuestionType = {
  "OPEN": "OPEN",
  "ONE_OPTION": "ONE_OPTION",
  "MULTIPLE_OPTIONS": "MULTIPLE_OPTIONS"
};

const TestType = {
  "PRACTICE": "PRACTICE",
  "EVALUATION": "EVALUATION",
  "FINAL": "FINAL"
};

const { Profile, TestExecution, Test, PossibleAnswer, Question } = initSchema(schema);

export {
  Profile,
  TestExecution,
  Test,
  TestExecutionStatus,
  QuestionType,
  TestType,
  PossibleAnswer,
  Question
};